import { PublicProductCard } from "~/features/products/PublicProductCard";

type PublicPocProduct = {
  product_guid: string;
  name: string;
  description?: string;
  specimen_type?: "BLOOD" | "SALIVA" | "URINE" | "STOOL" | string;
  selling_price?: number;
};

export function PublicPocProductBox({ product, to }: { product: PublicPocProduct; to?: string }) {
  return (
    <PublicProductCard
      name={product.name}
      description={product.description}
      specimenType={product.specimen_type}
      sellingPrice={product.selling_price}
      to={to}
    />
  );
}
